//src/app/features/questionnaires/create/PrepareQuestionnaire/fields/businessFields.tsx
import { store } from 'app/redux/store';
import * as Yup from 'yup';
import { commonFields, commonValidationObject } from '../fields';
import { PrepareQuestionnaireState, updateKey } from '../slice';

export const businessFields: IBaseField<keyof PrepareQuestionnaireState>[] = [
  ...commonFields,
  {
    type: 'radio',
    name: 'isAoaSubscriber',
    label: 'Are you a Subscribed Business with Accountants On Air?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    dependencies: [
      {
        type: 'radio',
        predicate: (value) => value === 'yes',
        name: 'doesAccountantsOnAirDoYourBookKeepingServices',
        effect: (payload) => store.dispatch(updateKey(payload)),
        label: 'Does Accountants On Air do your Bookkeeping Services?',
        dependencies: [
          {
            type: 'radio',
            predicate: (value) => value === 'no',
            name: 'doYouHaveAFinancialStatement',
            effect: (payload) => store.dispatch(updateKey(payload)),
            label: 'Do you have a financial statement?',
          },
        ],
      },
    ],
  },
  {
    type: 'radio',
    name: 'doYouHaveAnyGrossIncomeForThisYearInQuestion',
    label: 'Do you have any Gross Income for this year in question?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    dependencies: [
      {
        predicate: (value) => value === 'yes',
        type: 'radio',
        name: 'above10kGrossIncome',
        label: 'Above $10K?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
      },
    ],
  },
  {
    type: 'radio',
    name: 'didYouHaveAnyExpensesForThisYearInQuestion',
    label: 'Did you have any expenses for this year in question?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    dependencies: [
      {
        type: 'radio',
        name: 'above10kExpenses',
        predicate: (value) => value === 'yes',
        label: 'Above $10K?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
      },
    ],
  },
  {
    type: 'radio',
    name: 'doYouHaveACheckingBusinessBankAccount',
    label: 'Do you have a checking Business Bank Account?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
  },
  {
    type: 'radio',
    name: 'doYouHavePayroll',
    label: 'Do you have Payroll?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    dependencies: [
      {
        type: 'information',
        label: () => (
          <div className="text-gray-700 text-sm">
            Payroll Report Required to Reconcile
          </div>
        ),
        name: 'payrollReportRequiredToReconcile',
        predicate: (v) => v === 'yes',
      },
    ],
  },

  {
    type: 'number',
    name: 'howManyEmployess',
    label: 'How many employess?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
  },
];

const required = Yup.string().nullable().required('required');
export const validationSchema = Yup.object().shape({
  ...commonValidationObject,
  isAoaSubscriber: required,
  doesAccountantsOnAirDoYourBookKeepingServices: Yup.string().when(
    'isAoaSubscriber',
    {
      is: 'yes',
      then: required,
      otherwise: Yup.string().nullable(),
    },
  ),
  doYouHaveAFinancialStatement: Yup.string().when(
    ['isAoaSubscriber', 'doesAccountantsOnAirDoYourBookKeepingServices'],
    {
      is: (
        isAoaSubscriber: string,
        doesAccountantsOnAirDoYourBookKeepingServices: string,
      ) =>
        isAoaSubscriber === 'yes' &&
        doesAccountantsOnAirDoYourBookKeepingServices === 'no',
      then: required,
      otherwise: Yup.string().nullable(),
    },
  ),
  doYouHaveAnyGrossIncomeForThisYearInQuestion: required,
  above10kGrossIncome: Yup.string().when(
    'doYouHaveAnyGrossIncomeForThisYearInQuestion',
    {
      is: 'yes',
      then: required,
      otherwise: Yup.string().nullable(),
    },
  ),

  didYouHaveAnyExpensesForThisYearInQuestion: required,
  above10kExpenses: Yup.string().when(
    'didYouHaveAnyExpensesForThisYearInQuestion',
    {
      is: 'yes',
      then: required,
      otherwise: Yup.string().nullable(),
    },
  ),

  doYouHaveACheckingBusinessBankAccount: required,
  doYouHavePayroll: required,
  howManyEmployess: required.test(
    'len',
    'Invalid number',
    (val: any) => +val >= 0,
  ),
});
